import { CareAppListActionFactory } from '../action-factory';
import { ReleaseNotesInterface, RssResponse } from './release-notes.reducer';

class ReleaseNotesActions extends CareAppListActionFactory<ReleaseNotesInterface> {
  constructor(modelName: string) {
    super(modelName);
  }

  get REQUEST_RETRIEVE_ALL() {
    return `[${this.type}][Request] Retrieve all`;
  }
  get RESPONSE_SUCCESS_RETRIEVE_ALL() {
    return `[${this.type}][Response][Success] Retrieve all`;
  }
  get RESPONSE_FAIL_RETRIEVE_ALL() {
    return `[${this.type}][Response][Fail] Retrieve all`;
  }

  RequestReleaseNotesAction() {
    return {
      type: this.REQUEST_RETRIEVE_ALL,
    };
  }

  ResponseSuccessRetrieveReleaseNotesAction(payload: RssResponse) {
    return {
      type: this.RESPONSE_SUCCESS_RETRIEVE_ALL,
      payload,
    };
  }

  ResponseFailRetrieveReleaseNotesAction(payload: { error: String }) {
    return {
      type: this.RESPONSE_FAIL_RETRIEVE_ALL,
      payload,
    };
  }
}
export const ReleaseNotes = new ReleaseNotesActions(`ReleaseNotes`);
